import type { SVGProps } from 'react';

export const SearchIcon = (
  props: Pick<SVGProps<SVGElement>, 'className' | 'width' | 'height' | 'color' | 'opacity'>,
) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 15C7.23858 15 5 12.7614 5 10C5 7.23858 7.23858 5 10 5C12.7614 5 15 7.23858 15 10C15 11.2006 14.5768 12.3024 13.8715 13.1644L18.8536 18.1464C19.0488 18.3417 19.0488 18.6583 18.8536 18.8536C18.6583 19.0488 18.3417 19.0488 18.1464 18.8536L13.1644 13.8715C12.3024 14.5768 11.2006 15 10 15ZM10 14C12.2091 14 14 12.2091 14 10C14 7.79086 12.2091 6 10 6C7.79086 6 6 7.79086 6 10C6 12.2091 7.79086 14 10 14Z"
      fill="#262E3D"
      fillOpacity="0.67"
    />
  </svg>
);
